import React, {Component} from 'react';
import { Container } from 'reactstrap';

import styles from './Section.css'

export default class Section extends Component {
    render() {
        const {grey, triangle, backgroundImage, greyGradient, pattern, header} = this.props;

        const classes = [];

      let colorClass = null;
      if(greyGradient) {
        colorClass = styles.greyGradient;
      }

      if(grey) {
        colorClass = styles.grey;
      }

      if(pattern) {
        colorClass = styles.pattern;
      }

      if(header) {
        classes.push(styles.header);
      }

        let bgImage = null;
        if(backgroundImage) {
          classes.push(styles.bgImageSection);
          bgImage = (
            <div className={styles.bgImage} style={{backgroundImage: "url('" + backgroundImage +"')"}} />
          );
        }


        if(triangle) {
            return (
              <section id={this.props.id} className={[styles.section, styles.polygonSection, colorClass, ...classes].join(' ')}>
                <div className={styles.polygon}>
                  <svg preserveAspectRatio="none" viewBox="0 0 100 100">
                    <polygon points="100,100 100,0 0,100" opacity="1"></polygon>
                  </svg>
                </div>
                <Container>
                  {this.props.children}
                </Container>
              </section>
            );
        }

        return (
            <section id={this.props.id} className={[styles.section, colorClass, ...classes].join(' ')}>
              {bgImage}
                <Container>
                    {this.props.children}
                </Container>
            </section>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Section/Section.js